import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ChevronDownIcon from './icons/ChevronDownIcon';

const CollapsedBar = ({ isOpen, onToggle, label }) => (
  <button
    type="button"
    className="collapsed-bar"
    onClick={onToggle}
    aria-label={isOpen ? 'Collapse AI Chat Assistant' : 'Expand AI Chat Assistant'}
    aria-expanded={isOpen}
  >
    <span className="collapsed-bar-label">
      <span className="indicator-dot" role="img" aria-label="AI Chat online indicator" />
      <span className="collapsed-bar-text">💬 {label}</span>
    </span>
    <span className={`chatbot-bar-chevron ${isOpen ? 'is-open' : ''}`} aria-hidden="true">
      <ChevronDownIcon />
    </span>
  </button>
);

CollapsedBar.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string
};

CollapsedBar.defaultProps = {
  isOpen: false,
  label: 'AI Chat'
};

export default memo(CollapsedBar);